import React from 'react';
import { FiUsers, FiMap, FiCheckCircle, FiClock } from 'react-icons/fi';

const font = "'Outfit', sans-serif";
const C = { text: '#1e1b4b', sub: '#6b7280', border: '#e0e7ff', white: '#fff' };

const HallManagerDashboard = () => {
    // We will fetch real stats later, keeping static for now
    const stats = [
        { label: 'Total Halls', val: '12', icon: <FiMap size={24} />, color: '#6366f1', bg: '#eef2ff' },
        { label: 'Total Capacity', val: '850', icon: <FiUsers size={24} />, color: '#10b981', bg: '#ecfdf5' },
        { label: 'Papers to Review', val: '5', icon: <FiCheckCircle size={24} />, color: '#f59e0b', bg: '#fffbeb' },
        { label: 'Supply Exams', val: '3', icon: <FiClock size={24} />, color: '#ef4444', bg: '#fef2f2' },
    ];

    return (
        <div style={{ fontFamily: font }}>
            <h1 style={{ fontSize: 24, fontWeight: 900, color: C.text, margin: '0 0 8px', letterSpacing: -0.5 }}>Overview</h1>
            <p style={{ color: C.sub, fontSize: 14, margin: '0 0 30px' }}>Manage examination halls, allocate seating, and review submitted question papers.</p>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 20, marginBottom: 40 }}>
                {stats.map((s, i) => (
                    <div key={i} style={{ background: C.white, borderRadius: 20, border: `1.5px solid ${C.border}`, padding: 24, display: 'flex', alignItems: 'center', gap: 20, boxShadow: '0 4px 12px rgba(99,102,241,0.05)' }}>
                        <div style={{ width: 56, height: 56, borderRadius: 16, background: s.bg, color: s.color, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {s.icon}
                        </div>
                        <div>
                            <div style={{ fontSize: 28, fontWeight: 900, color: C.text, lineHeight: 1 }}>{s.val}</div>
                            <div style={{ fontSize: 13, fontWeight: 700, color: C.sub, marginTop: 6, textTransform: 'uppercase', letterSpacing: 0.5 }}>{s.label}</div>
                        </div>
                    </div>
                ))}
            </div>

            <div style={{ background: C.white, borderRadius: 20, border: `1.5px solid ${C.border}`, padding: 30 }}>
                <h2 style={{ fontSize: 18, fontWeight: 800, color: C.text, margin: '0 0 15px' }}>Welcome, Hall Manager</h2>
                <p style={{ color: C.sub, fontSize: 14, lineHeight: 1.6, margin: 0 }}>
                    As an Examination Hall Manager, your primary responsibilities include:
                    <ul style={{ paddingLeft: 20, marginTop: 10 }}>
                        <li style={{ marginBottom: 6 }}>Adding and managing examination halls and their seating capacities.</li>
                        <li style={{ marginBottom: 6 }}>Allocating students to physical seats for upcoming exams.</li>
                        <li style={{ marginBottom: 6 }}>Scheduling and organizing Supply Exams.</li>
                        <li style={{ marginBottom: 6 }}>Reviewing, approving, or rejecting question papers submitted by teachers before print.</li>
                    </ul>
                </p>
            </div>
        </div>
    );
};

export default HallManagerDashboard;
